export const DELIVERY_PHONE_HINT =
  '请填写正确的物流公司与物流单号，自配送、咸亨自有物流、其他物流、专线、自提需要填写真实手机号。'

const PHONE_LOGISTICS_NAMES = new Set([
  '咸亨自有物流',
  '其他物流',
  '专线',
  '自提',
])

export interface DeliveryLogisticsOption {
  expressCode?: string
  expressCompany?: string
}

export function isPhoneDeliveryLogistics(
  option?: DeliveryLogisticsOption,
): boolean {
  return (
    option?.expressCode?.toLowerCase() === 'zps' ||
    PHONE_LOGISTICS_NAMES.has(option?.expressCompany || '')
  )
}
export const DELIVERY_PHONE_HINT =
  '请填写正确的物流公司与物流单号，自配送、咸亨自有物流、其他物流、专线、自提需要填写真实手机号。'

const PHONE_LOGISTICS_NAMES = new Set([
  '咸亨自有物流',
  '其他物流',
  '专线',
  '自提',
])

export interface DeliveryLogisticsOption {
  expressCode?: string
  expressCompany?: string
}

export function isPhoneDeliveryLogistics(
  option?: DeliveryLogisticsOption,
): boolean {
  return (
    option?.expressCode?.toLowerCase() === 'zps' ||
    PHONE_LOGISTICS_NAMES.has(option?.expressCompany || '')
  )
}
